export default __webpack_public_path__ + "static/media/newOrganization.f333cd68.svg";